import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-log-email-dialog',
  templateUrl: './log-email-dialog.component.html',
  standalone: false,
})
export class LogEmailDialogComponent {
  leadId: string;
  call: any = {};

  constructor(
    public dialogRef: MatDialogRef<LogEmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      leadId: string;
    },
  ) {
    this.leadId = data.leadId;
  }

  ngOnInit() {}

  ngAfterViewInit() {}

  btnSubmit_click() {
    this.dialogRef.close(true);
  }

  btnClose_click() {
    this.dialogRef.close(false);
  }
}
